function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { Text, Animated, View, TouchableOpacity, TouchableWithoutFeedback, ActivityIndicator, BackHandler, Modal, Platform } from 'react-native';
import PropTypes from 'prop-types';
import styles from './styles';
const HwBackHandler = BackHandler;
const HW_BACK_EVENT = 'hardwareBackPress';
const {
  OS
} = Platform;
export default class AwesomeAlert extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "_springShow", fromConstructor => {
      const {
        useNativeDriver = false
      } = this.props;
      this._toggleAlert(fromConstructor);
      Animated.spring(this.springValue, {
        toValue: 1,
        bounciness: 10,
        useNativeDriver
      }).start();
    });
    _defineProperty(this, "_springHide", () => {
      const {
        useNativeDriver = false
      } = this.props;
      if (this.state.showSelf === true) {
        Animated.spring(this.springValue, {
          toValue: 0,
          tension: 10,
          useNativeDriver
        }).start();
        setTimeout(() => {
          this._toggleAlert();
          this._onDismiss();
        }, 70);
      }
    });
    _defineProperty(this, "_toggleAlert", fromConstructor => {
      if (fromConstructor) this.state = {
        showSelf: true
      };else this.setState({
        showSelf: !this.state.showSelf
      });
    });
    _defineProperty(this, "_handleHwBackEvent", () => {
      const {
        closeOnHardwareBackPress
      } = this.props;
      if (this.state.showSelf && closeOnHardwareBackPress) {
        this._springHide();
        return true;
      } else if (!closeOnHardwareBackPress && this.state.showSelf) {
        return true;
      }
      return false;
    });
    _defineProperty(this, "_onTapOutside", () => {
      const {
        closeOnTouchOutside
      } = this.props;
      if (closeOnTouchOutside) this._springHide();
    });
    _defineProperty(this, "_onDismiss", () => {
      const {
        onDismiss
      } = this.props;
      onDismiss && onDismiss();
    });
    _defineProperty(this, "_renderButton", data => {
      const {
        testID,
        text,
        backgroundColor,
        buttonStyle,
        buttonTextStyle,
        onPress
      } = data;
      return /*#__PURE__*/React.createElement(TouchableOpacity, {
        testID: testID,
        onPress: onPress
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.button, {
          backgroundColor
        }, buttonStyle]
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles.buttonText, buttonTextStyle]
      }, text)));
    });
    _defineProperty(this, "_renderAlert", () => {
      const animation = {
        transform: [{
          scale: this.springValue
        }]
      };
      const {
        showProgress
      } = this.props;
      const {
        title,
        message,
        customView = null
      } = this.props;
      const {
        showCancelButton,
        cancelText,
        cancelButtonColor,
        cancelButtonStyle,
        cancelButtonTextStyle,
        onCancelPressed,
        cancelButtonTestID
      } = this.props;
      const {
        showConfirmButton,
        confirmText,
        confirmButtonColor,
        confirmButtonStyle,
        confirmButtonTextStyle,
        onConfirmPressed,
        confirmButtonTestID
      } = this.props;
      const {
        alertContainerStyle,
        overlayStyle,
        progressSize,
        progressColor,
        contentContainerStyle,
        contentStyle,
        titleStyle,
        messageStyle,
        actionContainerStyle
      } = this.props;
      const cancelButtonData = {
        testID: cancelButtonTestID,
        text: cancelText,
        backgroundColor: cancelButtonColor,
        buttonStyle: cancelButtonStyle,
        buttonTextStyle: cancelButtonTextStyle,
        onPress: onCancelPressed
      };
      const confirmButtonData = {
        testID: confirmButtonTestID,
        text: confirmText,
        backgroundColor: confirmButtonColor,
        buttonStyle: confirmButtonStyle,
        buttonTextStyle: confirmButtonTextStyle,
        onPress: onConfirmPressed
      };
      return /*#__PURE__*/React.createElement(View, {
        style: [styles.container, alertContainerStyle]
      }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
        onPress: this._onTapOutside
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.overlay, overlayStyle]
      })), /*#__PURE__*/React.createElement(Animated.View, {
        style: [styles.contentContainer, animation, contentContainerStyle]
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.content, contentStyle]
      }, showProgress ? /*#__PURE__*/React.createElement(ActivityIndicator, {
        size: progressSize,
        color: progressColor
      }) : null, title ? /*#__PURE__*/React.createElement(Text, {
        style: [styles.title, titleStyle]
      }, title) : null, message ? /*#__PURE__*/React.createElement(Text, {
        style: [styles.message, messageStyle]
      }, message) : null, customView), /*#__PURE__*/React.createElement(View, {
        style: [styles.action, actionContainerStyle]
      }, showCancelButton ? this._renderButton(cancelButtonData) : null, showConfirmButton ? this._renderButton(confirmButtonData) : null)));
    });
    const {
      show
    } = this.props;
    this.springValue = new Animated.Value(props.animatedValue);
    this.state = {
      showSelf: false
    };
    if (show) this._springShow(true);
  }
  componentDidMount() {
    HwBackHandler.addEventListener(HW_BACK_EVENT, this._handleHwBackEvent);
  }
  render() {
    const {
      show,
      showSelf
    } = this.state;
    const {
      modalProps = {},
      closeOnHardwareBackPress
    } = this.props;
    const wrapInModal = OS === 'android' || OS === 'ios';
    return showSelf ? wrapInModal ? /*#__PURE__*/React.createElement(Modal, _extends({
      animationType: "none",
      transparent: true,
      visible: show,
      onRequestClose: () => {
        if (showSelf && closeOnHardwareBackPress) {
          this._springHide();
        }
      }
    }, modalProps), this._renderAlert()) : this._renderAlert() : null;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      show
    } = nextProps;
    const {
      showSelf
    } = this.state;
    if (show && !showSelf) this._springShow();else if (show === false && showSelf) this._springHide();
  }
  componentWillUnmount() {
    HwBackHandler.removeEventListener(HW_BACK_EVENT, this._handleHwBackEvent);
  }
}
AwesomeAlert.propTypes = {
  show: PropTypes.bool,
  animatedValue: PropTypes.number,
  useNativeDriver: PropTypes.bool,
  showProgress: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  closeOnTouchOutside: PropTypes.bool,
  closeOnHardwareBackPress: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelButtonColor: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  onCancelPressed: PropTypes.func,
  onConfirmPressed: PropTypes.func,
  customView: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  modalProps: PropTypes.object,
  cancelButtonTestID: PropTypes.string,
  confirmButtonTestID: PropTypes.string
};
AwesomeAlert.defaultProps = {
  show: false,
  animatedValue: 0.3,
  useNativeDriver: false,
  showProgress: false,
  closeOnTouchOutside: true,
  closeOnHardwareBackPress: true,
  showCancelButton: false,
  showConfirmButton: false,
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  cancelButtonColor: '#D0D0D0',
  confirmButtonColor: '#AEDEF4',
  customView: null,
  modalProps: {},
  cancelButtonTestID: 'awesome-alert-cancel-btn',
  confirmButtonTestID: 'awesome-alert-confirm-btn'
};